@let blok = block();

<td>{{ blok.title }}</td>
